export function EnterKeyLabel() {
  return (
    <svg width="23" height="7" viewBox="0 0 23 7" fill="none" aria-hidden="true">
      <text
        x="0"
        y="7"
        fill="currentColor"
        fontFamily="Inter, sans-serif"
        fontSize="9"
        fontWeight="600"
      >
        Enter
      </text>
    </svg>
  )
}

export function EscapeKeyLabel() {
  return (
    <svg width="14" height="7" viewBox="0 0 14 7" fill="none" aria-hidden="true">
      <text
        x="0"
        y="7"
        fill="currentColor"
        fontFamily="Inter, sans-serif"
        fontSize="9"
        fontWeight="600"
      >
        Esc
      </text>
    </svg>
  )
}
